import { render, staticRenderFns } from "./updateDeliveryPreference.vue?vue&type=template&id=df145b22&scoped=true&"
import script from "./updateDeliveryPreference.vue?vue&type=script&lang=js&"
export * from "./updateDeliveryPreference.vue?vue&type=script&lang=js&"
import style0 from "./updateDeliveryPreference.vue?vue&type=style&index=0&id=df145b22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df145b22",
  null
  
)

export default component.exports